import app from './application';

const
  UserTypes = Object.freeze({
    ANONYMOUS: 'anonimo'
  }),
  Genders = Object.freeze({
    FEM: 'f',
    MAS: 'm'
  }),
  VOCUSER_READY = 'vocuser:ready',
  VOCUSER_DATA  = 'vocuser:userdata'
;

$(document).ready(function() {
  app.when(VOCUSER_READY).then(_onVocUserReady);
  $('body').on('vocento.gigya.products.onReady', function(event, gigyaux) {
    var gigyaUX;

    gigyaUX = gigyaux || window.gigyaUX;
    if (gigyaUX) {_onVocUserReady(gigyaUX);}
  });
});

/* Private */

function _ord() {
  return Math.random() * 10000000000000;
}

function _onVocUserReady(gigyaux) {
  if (gigyaux.getUserType() === UserTypes.ANONYMOUS) {
    $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=76171930?" width="1" height="1" border="0" />`);
  } else {
    $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=76172050?" width="1" height="1" border="0" />`);
    if (typeof Voonto !== 'undefined') {
      app.when(VOCUSER_DATA).then(function(userData) {
        var gender, age;

        // NOTE: vocUserData promise object
        if (userData.responseGetUserInfo) {
          gender = userData.responseGetUserInfo.user &&
            userData.responseGetUserInfo.user.gender ?
            userData.responseGetUserInfo.user.gender : null;
          age = userData.responseGetUserInfo.user &&
            userData.responseGetUserInfo.user.age ?
            userData.responseGetUserInfo.user.age : null;
        }
        _onVocUserData(gender, age);
      });
    } else {
      $('body').on('vocento.gigya.accounts.onDataReady', function(event) {
        var gender, age;

        // NOTE: vocUserData promise object
        if (event.gigya_event) {
          gender = event.gigya_event.profile &&
            event.gigya_event.profile.gender ?
            event.gigya_event.profile.gender : null;
          age = event.gigya_event.profile &&
            event.gigya_event.profile.age ?
            event.gigya_event.profile.age : null;
        }
        _onVocUserData(gender, age);
      });
    }
  }
}

function _onVocUserData(gender, age) {
  switch (gender) {
    case Genders.FEM:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868810?" width="1" height="1" border="0" />`);
      break;
    case Genders.MAS:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868570?" width="1" height="1" border="0" />`);
      break;
  }

  switch (true) {
    case '' !== age && 17 >= age:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75867610?" width="1" height="1" border="0" />`);
      break;
    case 18 <= age && 24 >= age:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75867850?" width="1" height="1" border="0" />`);
      break;
    case 25 <= age && 34 >= age:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75867970?" width="1" height="1" border="0" />`);
      break;
    case 35 <= age && 44 >= age:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868210?" width="1" height="1" border="0" />`);
      break;
    case 45 <= age && 54 >= age:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868330?" width="1" height="1" border="0" />`);
      break;
    case '' !== age && 54 > age:
      $('head').append(`<img src="//pubads.g.doubleclick.net/activity;dc_iu=/4900/pixel.bfp.vocento;ord=${_ord()};dc_seg=75868450?" width="1" height="1" border="0" />`);
      break;
  }
}



// WEBPACK FOOTER //
// ./src/dfp-pixel.js